import React from "react";
import { useSelector } from "react-redux";

const Inputselect = (props) => {
  const { options, value, onChange, label } = props;
  const { darkTheme } = useSelector((state) => state.styles);

  return (
    <div className={`input-select ${darkTheme ? "" : "light"}`}>
      <select value={value} onChange={onChange}>
        {/* <option value="">{label}</option> */}
        {options.map((item, i) => (
          <option key={i} value={JSON.stringify(item)}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Inputselect;
